import { lazy as loadable } from 'react';

export default loadable(() => import('./index'));
